// src/utils/auth.ts

const TOKEN_KEY = 'authToken';

/**
 * Get the authentication token from localStorage
 * @returns {string | null} Token or null if not available
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * Set the authentication token in localStorage
 * @param {string} token - JWT token
 */
export const setAuthToken = (token: string) => {
  localStorage.setItem(TOKEN_KEY, token);
};

/**
 * Remove the authentication token from localStorage
 */
export const removeAuthToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

export const clearLocalSessionStorage = () => {
  const keep = new Set(['osano_consentmanager', 'osano_consentmanager_uuid']);

  for (const storage of [localStorage, sessionStorage]) {
    for (const key of Object.keys(storage)) {
      if (!keep.has(key)) {
        storage.removeItem(key);
      }
    }
  }
};
